import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { ButtonType } from '@sc/data-access-models';
import { IconComponent } from '../icon/icon.component';
import { NgStyle, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'sc-button-old',
  styleUrls: ['./button-old.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      mat-raised-button
      [disabled]="disabled"
      [class]="buttonClass"
      [ngStyle]="{
        width: widthInPx ? widthInPx + 'px' : '100%',
        'font-size': fontSizeInPx + 'px'
      }"
      (click)="onClick()"
      [attr.aria-disabled]="disabled ? true : undefined"
      tabindex="0"
    >
      <span class="button-old-container">
        <sc-icon *ngIf="prefixIcon" [name]="prefixIcon"></sc-icon>
        <span *ngIf="prefixIcon" class="spacer"></span>
        <span>{{ text }}</span>
        <span *ngIf="prefixIcon" class="spacer"></span>
        <sc-icon *ngIf="suffixIcon" [name]="suffixIcon"></sc-icon>
      </span>
    </button>
  `,
  imports: [MatButtonModule, NgStyle, NgIf, IconComponent],
})
export class ButtonOldComponent {
  @Input() buttonType: ButtonType;
  @Input() text: string;
  @Input() prefixIcon: IconName;
  @Input() suffixIcon: IconName;
  @Input() disabled: boolean;

  @Input() widthInPx: string | number;
  @Input() fontSizeInPx = '20';
  @Input() prefixIconAlt: string;
  @Input() suffixIconAlt: string;

  @Output() buttonClick = new EventEmitter<void>();

  get buttonClass() {
    switch (this.buttonType) {
      case 'PRIMARY':
        return 'primary';
      case 'SECONDARY':
        return 'secondary';
      case 'DISABLED':
        return 'disabled';
      case 'WARN':
        return 'warn';
      default:
        return 'primary';
    }
  }

  onClick(): void {
    this.buttonClick.emit();
  }
}
